<h2 mat-dialog-title>Edit workshop job {{ data.id }}</h2>
<form [formGroup]="form">
  <mat-dialog-content>
    <div class="flex flex-col items-stretch">
      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select formControlName="type" name="type">
          <mat-option *ngFor="let type of types" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Defect details</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="4"
          formControlName="details"
          name="details"
        ></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Notes</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="4"
          formControlName="notes"
          name="notes"
        ></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button (click)="save()">Save</button>
  </div>
</form>
